import React from 'react'
import Section, { StyledH2, StyledH3 } from './Section'
import { QuestionUtils } from '../../utils/siteUtils'
import { ExteriorPageNumber, GlassPageNumber, InteriorPageNumber, MechanicalPageNumber } from '../../constants'

let sections = [
  { title: 'Exterior', pg: ExteriorPageNumber, subsections: ['driverside', 'passengerside', 'frontwithgrille', 'rear'] },
  { title: 'Glass, Wheels, and Brakes', pg: GlassPageNumber, subsections: ['GlassLights', 'WheelsBrakes'] },
  { title: 'Interior', pg: InteriorPageNumber, subsections: ['interior', 'warninglights'] },
  { title: 'Mechanical', pg: MechanicalPageNumber, subsections: ['MechanicalIssues'] }
]

const VehicleConditionSections = ({ calculateViewChange, prospectDocuments, navigatePageWithState, anyAnswered, getQuestionResponseComment, getQuestionResponse, isQuestionAnswered, getQuestionAnswerValues, canEdit }) => {
  // dont use prospect, use funnel conditions page stuff
  const getQuestionAnswer = question => {
    let answer = undefined
    switch (question.questionType) {
      case 'ToggleSelect':
        answer = 'True'
        break
      case 'Integer':
        answer = getQuestionResponse(question.questionId).v
        break
      case 'MultiSelect':
        answer = getQuestionAnswerValues(question)
        break
      case 'SingleSelect':
        answer = getQuestionAnswerValues(question)
        break
      case 'Boolean':
        const enumChoices = question.enumChoices.length ? question.enumChoices : ['Yes', 'No']
        answer = enumChoices[getQuestionResponse(question.questionId).v]
        break
      default:
        answer = 0
        break
    }
    return answer
  }
  const conditionQuestions = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qc').items.filter(item => item.section === 'Vehicle Condition')
  const odorQuestion = prospectDocuments.documents && prospectDocuments.documents.find(document => document.id.split('/')[0] === 'qp').items.find(q => q.questionId === 'qp/65')
  const toggleOdorQuestion = { ...odorQuestion, label: 'Smoking/Other Odors', questionType: 'Boolean', section: 'Vehicle Condition', item: 'Odors', subsection: 'Interior Wear or Damage', subsectionCode: 'interior' }
  prospectDocuments && prospectDocuments.documents && conditionQuestions.push(toggleOdorQuestion)
  const loaded = !!conditionQuestions
  let uniqueViewStr = 'uniqueViewStr:'

  sections = [
    { title: 'Exterior', pg: ExteriorPageNumber, subsections: ['driverside', 'passengerside', 'frontwithgrille', 'rear'] },
    { title: 'Glass, Wheels, and Brakes', pg: ExteriorPageNumber, subsections: ['GlassLights', 'WheelsBrakes'] },
    { title: 'Interior', pg: ExteriorPageNumber, subsections: ['interior', 'warninglights'] },
    { title: 'Mechanical', pg: ExteriorPageNumber, subsections: ['MechanicalIssues'] }
  ]

  const component = (
    <>
      {sections.map((section, index) => (
        <Section key={index} title={'Vehicle Condition - ' + section.title} showEdit={canEdit} onClick={e => navigatePageWithState({ p: section.pg })}>
          {section.subsections
            .map((subsection, index) => {
              const representativeQuestion = conditionQuestions && conditionQuestions.find(question => question.subsectionCode && subsection.toLowerCase().includes(question.subsectionCode.toLowerCase()))
              const title = representativeQuestion && representativeQuestion.subsection
              const subsectionAnswers =
                representativeQuestion && QuestionUtils.getItems(conditionQuestions, representativeQuestion.subsectionCode).filter(item => anyAnswered(QuestionUtils.getAssociatedQuestions(conditionQuestions, item, representativeQuestion.subsectionCode)))
              uniqueViewStr += title
              return (
                subsectionAnswers &&
                !!subsectionAnswers.length && (
                  <React.Fragment key={index}>
                    <StyledH2>{title}</StyledH2>
                    {subsection === 'warninglights' && 'Lights On: '}
                    {subsectionAnswers.map((name, index) => {
                      const answeredQuestions = QuestionUtils.getAssociatedQuestions(conditionQuestions, QuestionUtils.translateName(name), subsection).filter(x => isQuestionAnswered(x))
                      if (subsection === 'warninglights') {
                        const val = answeredQuestions[0].item + (index < subsectionAnswers.length - 1 ? ', ' : '')
                        uniqueViewStr += val
                        return val
                      }
                      uniqueViewStr += answeredQuestions[0].item
                      return (
                        <React.Fragment key={index}>
                          <StyledH3>{answeredQuestions[0].item}</StyledH3>
                          {answeredQuestions.map(q => {
                            const answers = getQuestionAnswer(q) === 'True' ? 'Yes' : getQuestionAnswer(q)
                            const mappedAnswers = answers.map
                              ? answers.map((answer, index) => {
                                  const qRef = (q.selectChoices.find(choice => choice.value === answer) || {}).qRef

                                  return { a: answer, c: getQuestionResponseComment(qRef) }
                                })
                              : [{ a: answers, c: getQuestionResponseComment(q.questionId) }]

                            return mappedAnswers.map((answer, index) => {
                              uniqueViewStr += (q.label ? q.label : q.item) + answer.a + answer.c
                              return (
                                <div key={index}>
                                  <span>{q.label ? q.label : q.item}:</span> {answer.a}
                                  <br />
                                  {answer.c && `Explanation: ${answer.c}`}
                                </div>
                              )
                            })
                          })}
                        </React.Fragment>
                      )
                    })}
                  </React.Fragment>
                )
              )
            })
            .filter(x => !!x)}
        </Section>
      ))}
    </>
  )
  calculateViewChange('vehicleCondition', loaded && uniqueViewStr)
  return component
}

export default VehicleConditionSections
